import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { go } from '@/utils';
import styles from './index.less';


interface PageEntryProps {
  title: string;
  name: string;
  path: string;
  icon: FC<{}>;
  themeColor: string;
  getUnreadCount: (name: UKey) => number | Promise<number>;
}

const PageEntry: FC<PageEntryProps> = ({ title, name, path, icon, themeColor, getUnreadCount }) => {
  const history = useHistory();
  const [unread, setUnread] = useState<number | void>();

  useEffect(() => {
    if (getUnreadCount) {
      const unreadCount = getUnreadCount(name);
      if (typeof unreadCount === 'number' || typeof unreadCount === 'string') {
        setUnread(Number(unreadCount));
      } else if (unreadCount instanceof Promise) {
        unreadCount.then(res => setUnread(Number(res)));
      }
    } else {
      setUnread();
    }
  }, [getUnreadCount, name]);

  function handleEnter() {
    go(history, path);
  }
  
  const Icon = icon;

  return (
    <div className={styles.wrapper} onClick={handleEnter}>
      <div className={styles.icon} style={{ backgroundColor: themeColor }}>
        <Icon />
        {unread ? <sup>{unread > 99 ? '99+' : unread}</sup> : null}
      </div>
      <div className={styles.name}>{title}</div>
    </div>
  )
}

export default PageEntry;
